import Api from '../config/api'

export const findByUnidadeLogadaConfiguracaoUnidade = () =>
  Api.post('', {
    query: `
        query {
          findByUnidadeLogadaConfiguracaoUnidade{
              utilizaMensagemPersonalizada
              azulControleAtivado
              enviaConfirmacaoDoisDiasAntes
              enviaConfirmacaoDoisDiasAntesSala
              enviaConfirmacaoUmDiasAntes
              enviaConfirmacaoUmDiasAntesSala
              enviaConfirmacaoUmaHoraAntes
              enviaConfirmacaoUmaHoraAntesSala
              marcarFaltososAutomaticamente
              numeroHorasBloqueioAgendamento
              notificaValorZeroAzulControle
              notificaAzulControleAgendamentoSala
              numeroHorasCancelamentoAutomatico
              utilizaTelefoneInternacional
              enviaConfirmacaoAntecipaFinalDeSemana
              horasPermiteConfirmarAgendamento
              enviaMensagemConfirmacaoEmail
              utilizaEnderecoMensagemAgendamento
              confirmaPresencaAgendamento
              validaAgendamentoMesmoHorario
              utilizaControleSessao
              utilizaFotoUnidadeGuiaSadt
              permiteAdministradorVerProntuarios
              utilizaWaba
              utilizaConfiguracaoRepasse
              utilizaConvenioAgendamento
              assinaturaDigitalObrigatoria
              utilizaImpressaoCartao
              utilizaPlugzapi
              utilizaCidObrigatorio
              permiteAtualizarAgendamentoSituacaoFuturo
              utilizaFinanceiroAppHealth
              visualizarAgendamentoRede
              cadastroRapidoAgendamento
              utilizaContratoAzulControle
              mostrarHorariosBloqueados
              permiteDuplicidadeCPF
              limiteDescontoOrcamento
              faturamentoObrigatorio
              mostrarApenasProfissionaisAtivo
              utilizaEtiquetaIdentificacao
              filtroProcedimento
              preencherTipoConsulta
              realizaInternacao
              situacoesNotificaAzulControle
              utilizaMotivoDeCancelamentoDoAgendamento
              utilizaReagendamento
              permiteDuplicidadeOrcamento
              quantidadeReagendamentoSujeitoAtencao
              utilizaDuracaoProcedimentosTipoConsulta
              utilizaAssinaturaPresenca
              utilizaValorCustoProcedimento
              utilizaDasa
              permiteCompartilharProntuarioEntreUnidades
              utilizaRepasseAutomaticoProcedimentoOrcamento
              utilizaImpressaoDetalhadaOrcamentoOdontologico
              mostrarApenasProcedimentoOdontologicoFaturado
              utilizaFiltroDeProcedimentosPorConvenio
              utilizaBaixaReceita
              utilizaAsaas
              permiteAtendimentoOrcamentoAprovado
              permiteFinalizarProcedimentoOdontologicoSemFaturamento
              mostrarObservacaoImpressaoAgenda
              obrigaEvolucaoProntuario
              utilizaIdPersonalizadoPaciente
              filtroConvenioPor
              camposSujeitoAtencao {
                campo
                status
                id
              }
              unidade{
                id
              }
              dadosDasa{
                 entidade
                id
                idAgente
                senha
              }
              utilizaPacsweb
              utilizaChatwoot
              permiteBuscaProcedimentoNaoVinculado
            }
        }
    `,
  })

export const saveConfiguracaoUnidade = async configuracaoUnidade => {
  return await Api.post('', {
    query: `
      mutation($configuracaoUnidade:ConfiguracaoUnidadeInput){
        updateConfiguracaoUnidade(configuracaoUnidade: $configuracaoUnidade){
            unidade{
              id
            }
          }
        }
        `,
    variables: { ...configuracaoUnidade },
  })
}

export const findGroupByRedeLogadaWithoutIAPermissions = async () => {
  const response = await Api.post('', {
    query: `
      query ($ativo: Boolean) {
        findGroupByRedeLogadaWithoutIAPermissions(ativo: $ativo) {
          id
          nome
        }
      } 
    `,
    variables: { ativo: true }
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  }
  return response.data.data.findGroupByRedeLogadaWithoutIAPermissions
}

export const getConfiguracaoUnidadeRealizaInternacao = async() => {
  const response = await Api.post('', {
    query: `
      query {
        findByUnidadeLogadaConfiguracaoUnidade{
          realizaInternacao
        }
      }
    `,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  }

  return response.data.data.findByUnidadeLogadaConfiguracaoUnidade.realizaInternacao;
}

export const updateDadosDasa = async (variables)=>{
  const response = await Api.post("",{
    query:`mutation UpdateDadosDasa($dadosDasa: DadosDasaInput) {
  updateDadosDasa(dadosDasa: $dadosDasa) {
    entidade
    id
    idAgente
    senha
    status
  }
}`,variables
  })
  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  }

  return response.data.data.updateDadosDasa;
}

export const getConfiguracaoUnidadeProntuario = async ()=>{
  const response = await Api.post('', {
      query: `
          query {
            findByUnidadeLogadaConfiguracaoUnidade {
                utilizaPlugzapi
              }
          }
      `,
    });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  }

  return response.data.data.findByUnidadeLogadaConfiguracaoUnidade;
}

export const findConfiguracaoUnidade = async () => {
  const response = await Api.post('', {
    query: `
          query {
            findByUnidadeLogadaConfiguracaoUnidade {
               utilizaFiltroDeProcedimentosPorConvenio}}`
    ,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  }

  return response.data.data.findByUnidadeLogadaConfiguracaoUnidade;
}

export const getUtilizaValorAgendamentoTipoProfissional = async () => {
  const response = await Api.post('', {
    query: `
      query {
        findByUnidadeLogadaConfiguracaoUnidade{
          utilizaValorAgendamentoTipoProfissional
        }
      }
    `,
  });

  if (response.data.errors) {
    throw Error(response.data.errors[0].message)
  }

  return response.data.data.findByUnidadeLogadaConfiguracaoUnidade.utilizaValorAgendamentoTipoProfissional;
}
